module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.85f12b8b.svg";